import React from 'react';
import Search from './search/search.js';
import Description from './description/description.js';
import History from './history/history.js';
import Advantages from './advantages/advantages.js';
import './home.scss';

export function Home() {
  return (
    <main>
      <Search />
      <Description />
      <History />
      <Advantages />
    </main>
  );
}

export default Home;
